import {
  SystemModel,
  MenuItemModel,
  MenuyPowerModel,
  MenuObjModel,
  SdkView,
} from "@/interface/model";
import { reactive, UnwrapRef, watch } from "vue";
import qs from "qs";
import { ServiceSource } from "@/enum/service-source";
import { Language } from "@/enum/language";
import { OperateSystem } from "@/enum/operate-system";

import dsBridge from "dsbridge";
import { httpService } from "./http";
import { i18nService } from "./i18n";
import { I18nLang } from "nebula-mobile/src/i18n/interface";
import YSF from "@neysf/qiyu-web-sdk";

import { ref } from "vue";
import { useToast } from "nebula-mobile";
const isInFeiyuSdk = () => {
  // @ts-ignore
  return (
    // @ts-ignore
    window._dsbridge ||
    // @ts-ignore
    window._dswk ||
    // @ts-ignore
    navigator.userAgent.indexOf("_dsbridge") != -1
  );
};

const getSdkInitParams = (): Promise<SystemModel> => {
  return new Promise((resolve, reject) => {
    try {
      dsBridge.registerAsyn("doInit", function (data: string) {
        const params: SystemModel = JSON.parse(data);
        resolve(params);
      });
    } catch (error) {
      reject(error);
    }
  });
};

const getSdkSign = (openId = ""): Promise<string> => {
  return new Promise((resolve, reject) => {
    try {
      dsBridge.call(
        "FYServiceJSInterface.asynHandler",
        { action: "getSourceSign", data: { openId } },
        function (data: string) {
          const { sign } = JSON.parse(data);
          resolve(sign);
        }
      );
    } catch (error) {
      reject(error);
    }
  });
};

const showBackToPrevView = (show: boolean) => {
  return new Promise((resolve, reject) => {
    try {
      dsBridge.call(
        "FYServiceJSInterface.asynHandler",
        { action: "showBack", data: { show: show ? "1" : "0" } },
        function () {
          resolve(null);
        }
      );
    } catch (error) {
      reject(error);
    }
  });
};

const createDevelopParams = (): SystemModel => {
  return {
    view: "record",
    app_id: 30035,
    app_key: "6c1c9ba3d62d370b24eb9deb9d6d9574",
    company_id: 75,
    source: ServiceSource.FeiYuWeChat,
    open_id: "2857b106735ba571f7cd540388c52ed6",
    channel_id: 75,
    language: Language.SimplifiedChinese,
    game_version: "v1.0.0",
    device_model: "android 2.0",
    os_version: "v4.5",
    os: OperateSystem.Android,
    server_id: 1,
    server_name: "",
    player_id: 0,
    player_level: "",
    player_level_vip: "",
    sign: "92e8cf99d8683fbeb3c48bf7b2ddc3e3",
    sdk_version: "v1.0.0",
    device_id: "device_id_001",
    nickname: "Nebula",
    profile_photo:
      "http://pms-1251262620.cosgz.myqcloud.com/953e4df3ccf743da1471f7e7092bd2de.png",
    app_name: "保卫萝卜",
    sex: "",
    group_id: "",
    token: "",
    game_issued: "1",
    default_page: "", // 进入客服专区默认定位的页面
  };
};

let sdkOptions!: UnwrapRef<SystemModel>;

let qiyuOptions: { templateId: number; userPrefix: string } | null = null;

export const createSdkService = async () => {
  // 判断是否在SDK内部，读取SDK参数配置

  if (isInFeiyuSdk()) {
    const params = await getSdkInitParams();
    sdkOptions = reactive(params);
    sdkOptions.sign = await getSdkSign(params.open_id);
  }

  const urlParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  const sdkUrlParams: Record<string, unknown> = {};
  for (const key in urlParams) {
    if (key === "_next") continue;
    if (!key.startsWith("_")) {
      sdkUrlParams[key] = urlParams[key];
      continue;
    }
    const optKey = key.slice(1);
    sdkUrlParams[optKey] = urlParams[key];
  }

  if (sdkOptions) {
    Object.assign(sdkOptions, sdkUrlParams as unknown as SystemModel);
  } else {
    sdkOptions = reactive(sdkUrlParams as unknown as SystemModel);
  }

  // 开发环境读取手动配置参数
  if (process.env.NODE_ENV === "development") {
    const params = createDevelopParams();
    sdkOptions = reactive(params);
  }

  // 没有参数设置为0，后台参数保持一致
  if (!sdkOptions.channel_id) {
    sdkOptions.channel_id = 0;
  }

  // 没有参数设置为0，后台参数保持一致
  if (!sdkOptions.server_id) {
    sdkOptions.server_id = 0;
  }

  // 没有参数设置为0，后台参数保持一致
  if (!sdkOptions.player_id) {
    sdkOptions.player_id = 0;
  }

  if (
    sdkOptions.source === ServiceSource.BeforeLogin ||
    sdkOptions.source === ServiceSource.AfterLogin ||
    sdkOptions.source === ServiceSource.EnterGame ||
    sdkOptions.source === ServiceSource.CommonWeChat ||
    sdkOptions.source === ServiceSource.AppWeb
  ) {
    const { result, data } = await httpService.get<Record<string, string>>({
      url: "/csapi3.0/config",
    });
    // 七鱼客服使用简体中文
    if (result && data?.use_system === "2") {
      sdkOptions.language = Language.SimplifiedChinese;
      qiyuOptions = {
        templateId: Number(data.qiyu_template_id ?? 0),
        userPrefix: data.qiyu_user_prefix ?? "",
      };
    }
  }

  const languages: Record<Language, I18nLang> = {
    [Language.SimplifiedChinese]: "zh_CN",
    [Language.TraditionalChinese]: "zh_TW",
    [Language.English]: "en_US",
  };

  const sdkLanguage = languages[sdkOptions.language];
  if (!sdkLanguage) {
    // 无法获取语言环境
    // 入口为非SDK，显示简体中文，SDK内，则显示英文
    sdkOptions.language = isInFeiyuSdk()
      ? Language.English
      : Language.SimplifiedChinese;
  }
  i18nService.locale(languages[sdkOptions.language]);

  watch(
    () => sdkOptions.open_id,
    async () => {
      sdkOptions.sign = await getSdkSign(sdkOptions.open_id);
    },
    { immediate: true }
  );

  return sdkOptions;
};

export const sdkService = {
  get options() {
    return sdkOptions;
  },

  encrypt(value: string) {
    if (!isInFeiyuSdk()) return value;

    const isEncryptFunc = dsBridge.hasNativeMethod(
      "FYServiceJSInterface.asySecureHandler",
      "all"
    );
    if (!isEncryptFunc) return value;
    return new Promise((reslove) => {
      dsBridge.call(
        "FYServiceJSInterface.asySecureHandler",
        {
          action: "getEncrypt",
          data: { secureString: value },
        },
        (data) => {
          reslove(JSON.parse(data).encrypt);
        }
      );
    });
  },

  decrypt(value: string) {
    if (!isInFeiyuSdk()) return value;

    const isEncryptFunc = dsBridge.hasNativeMethod(
      "FYServiceJSInterface.asySecureHandler",
      "all"
    );
    if (!isEncryptFunc) return value;
    return new Promise((reslove) => {
      dsBridge.call(
        "FYServiceJSInterface.asySecureHandler",
        {
          action: "getDecrypt",
          data: { secureString: value },
        },
        (data) => {
          reslove(JSON.parse(data).decrypt);
        }
      );
    });
  },

  updateOptions(options: Partial<typeof sdkOptions> = {}) {
    Object.assign(sdkOptions, options);
  },

  async fetchFirstRoute() {
    // 根据游戏是否开启常见问题菜单进行设置默认菜单
    const { result, data } = await httpService.get<MenuItemModel>({
      url: "/csapi3.0/knowledge/access",
    });
    let isShowFeedback = false;
    const menuyPower = ref<MenuyPowerModel>({
      menu: [
        {
          view: "knowledge",
          type: "enable_knowledge",
          value: "/common-problem",
          visible: 1,
        },
        {
          view: "sns",
          type: "enable_sns",
          value: "/qa",
          visible: 0,
        },
        {
          view: "service",
          type: "enable_service",
          value: "/contact-service",
          visible: 1,
        },
        {
          view: "record",
          type: "enable_record",
          value: "/feedback",
          visible: 1,
        },
      ],
      first: "/common-problem",
      isShowFeedback: false,
    });

    menuyPower.value.menu.map((ele) => {
      Object.keys(data).forEach((key: string) => {
        if (ele.type == key) {
          ele.visible = Number(data[key]);
          if (key == "enable_record") {
            isShowFeedback = Number(data[key]) == 1 ? true : false;
          }
        }
      });
    });

    const defaultPage = sdkOptions.default_page || "";
    if (defaultPage) {
      const view = defaultPage.split("_") ? defaultPage.split("_")[0] : "";
      if (view) sdkOptions.view = view as SdkView;
    }

    let firstMenu: MenuObjModel | undefined;
    if (sdkOptions.view) {
      firstMenu = menuyPower.value.menu.find(
        (m) => m.view === sdkOptions.view && m.visible && m.view !== "sns"
      );
    }
    if (!firstMenu) {
      firstMenu = menuyPower.value.menu.find(
        (m) => m.visible && m.view !== "sns"
      );
    }

    if (firstMenu) {
      menuyPower.value.first = firstMenu.value;
    }

    menuyPower.value.isShowFeedback = isShowFeedback;

    if (!result) {
      return [menuyPower];
    }
    return menuyPower;
  },

  get useQiyu() {
    return qiyuOptions;
  },

  async updateQiyuOptions() {
    const { result, data } = await httpService.get<Record<string, string>>({
      url: "/csapi3.0/config",
    });
    // 七鱼客服使用简体中文
    if (result && data?.use_system === "2") {
      sdkOptions.language = Language.SimplifiedChinese;
      qiyuOptions = {
        templateId: Number(data.qiyu_template_id ?? 0),
        userPrefix: data.qiyu_user_prefix ?? "",
      };
    } else {
      qiyuOptions = null;
    }
  },

  async openQiyuService() {
    if (!this.useQiyu) return;
    const ysf = await YSF.init("c162d65bae3fc1bdfe20d0c65ab5cb60", {
      sessionInvite: false,
      hidden: true,
      sdkTemplateId: qiyuOptions!.templateId,
    } as Record<string, unknown>);

    const { result, data } = await httpService.post<Record<string, unknown>>({
      url: "/csapi3.0/qiyu/crm/getReportInfo",
      data: {
        app_id: sdkOptions.app_id,
        open_id: sdkOptions.open_id,
        source: sdkOptions.source,
        nb_submit_channel_id: sdkOptions.channel_id,
        nb_submit_game_version: sdkOptions.game_version,
        nb_submit_device_type: sdkOptions.device_model,
        nb_submit_service_id: sdkOptions.server_id,
        nb_submit_service_name: sdkOptions.server_name,
        nb_submit_role_id: sdkOptions.player_id,
        nb_submit_role_name: sdkOptions.player_name,
      },
    });
    if (!result) {
      const toast = useToast();
      toast.info({ content: "客服异常" });
      return;
    }

    (ysf as unknown as Record<string, (options: unknown) => void>).config({
      uid: data.uid,
      level: data.level,
      title: `${data.game_name}(${data.app_id})`,
      referrer: `https://cs-nebula.737.com/${data.app_id}`,
      data: JSON.stringify(data.data),
      authToken: data.auth_token,
      success: () => {
        setTimeout(() => {
          window.location.href = ysf("url") as unknown as string;
        }, 300);
      },
      fail: () => {
        const toast = useToast();
        toast.info({ content: "客服异常" });
      },
    });
  },

  showBackToPrevView,
};
